export enum PeriodType {
    All = "all",
    Year = "year",
    Month = "month",
    Week = "week"
}